import { useEffect } from 'react';
import {
    addBalanceChangeListener,
    closeBalanceSyncChannel,
    startExternalBalanceRefresh,
    stopExternalBalanceRefresh,
} from '../lib/balance-sync';
import { refreshBalance } from '../stores/balance';

export const useBalanceRefresh = () => {
    useEffect(() => {
        const unsubscribe = addBalanceChangeListener(() => {
            startExternalBalanceRefresh();

            refreshBalance().finally(() => {
                stopExternalBalanceRefresh();
            });
        });

        return () => {
            unsubscribe();
            closeBalanceSyncChannel();
        };
    }, []);
};
